import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  mfaSendingTitle: 'Transferring your funds',
  mfaSendingDescription: 'This may take a few short moments.',
  mfaSuccessTitle: 'Transfer Complete',
  mfaSuccessDescription: 'Your funds have been successfully transferred.',
  mfaSuccessPrimaryButtonLabel: 'Make Another Transfer',
  mfaSuccessSecondaryButtonLabel: 'Back to All Accounts',
  mfaErrorTitle: 'Something went wrong',
  mfaErrorDescription1: 'We were unable to process your transfer.',
  mfaErrorDescription2: 'Please contact our Support team at 1800 935 537.',
  mfaErrorSecondaryButtonLabel: 'Back to All Accounts',
})
